import { ChartTimeSeriesLineTheme } from '@hcs/design-system';
import { DateStr } from '@hcs/types';
import { CerberusStatsFields } from '@hcs/types';

import { CerberusStatsListingStatsChart } from '../../components';
import { MACRO_INSIGHTS_FROM_DATE } from '../../constants';
import { useCityListingStatsTimeSeries } from '../../hooks';
import { getIsRentalListingStatsField } from '../../utils';

interface CityListingStatsLineChartProps {
  className?: string;
  placeId: string;
  fromDate?: DateStr;
  toDate?: DateStr;
  cerberusStatsField: CerberusStatsFields;
  theme?: Partial<ChartTimeSeriesLineTheme>;
  propertyType: 'singleFamily' | 'condo';
  setPropertyType?: (propertyType: 'singleFamily' | 'condo') => void;
  showPropertyTypeWarning?: boolean;
}

export const CityListingStatsChart = ({
  className,
  placeId,
  fromDate = MACRO_INSIGHTS_FROM_DATE,
  toDate,
  cerberusStatsField,
  theme,
  propertyType,
  setPropertyType,
  showPropertyTypeWarning,
}: CityListingStatsLineChartProps) => {
  const dataHcName = `city-${cerberusStatsField}-chart`;
  const { data, isLoading } = useCityListingStatsTimeSeries({
    placeId,
    fromDate,
    toDate,
    propertyType,
  });
  const isRentalField = getIsRentalListingStatsField(cerberusStatsField);

  return (
    <CerberusStatsListingStatsChart
      dataHcName={dataHcName}
      className={className}
      theme={theme}
      cerberusStatsField={cerberusStatsField}
      isRentalField={isRentalField}
      isLoading={isLoading}
      data={isRentalField ? data?.rentalListingStats : data?.saleListingStats}
      propertyType={propertyType}
      setPropertyType={setPropertyType}
      showPropertyTypeWarning={showPropertyTypeWarning}
    />
  );
};
